import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Flex, Modal, Row, Space } from "antd";
import { Alert } from "components/elements";
import TableAntd from "components/elements/Table/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import ProductManagementEdit from "../components/ProductManagementEdit";
import * as services from "../services/productManagementApi";
import { setIsLoading, setProductList, } from "../slices/productManagementSlice";
import styles from "../styles/BeCashStyles.module.css";

const useProductManagement = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const { productList, isLoading } = useSelector((state) => state?.productManagement)
    const [dataSource, setDataSource] = useState([])
    const [fileList, setFileList] = useState()
    const [openModal, setOpenModal] = useState(false)
    // console.log("dataSource", dataSource);
    const [pagination, setPagination] = useState({ page: 0, size: 10, pageSize: 10 });
    const [amountVisible, setAmountVisible] = useState(true)
    const [productCode, setProductCode] = useState(null)
    const currentCompany = useSelector((state) => state.company.currentCompany);

    const [state, setState] = useState({
        page: 'table'
    })

    useEffect(() => {

        setDataSource(productList?.map?.((o, index) => {
            return {
                index,
                ...o,
                productName: o?.product?.["name" + (i18n.language == 'en' ? "En" : "")],
            }
        }))

    }, [productList, i18n.language])

    const feeTypeOption = [
        {
            label: 'ค่าติดตามทวงถามหนี้',
            value: 'FEE_01'
        },
        {
            label: 'ค่าธรรมเนียมการใช้วงเงิน',
            value: 'FEE_02'
        }
    ]

    const updateProductManagement = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                let res = await services.updateProductManagement(values);
                Alert({ message: "Success" });
                // console.log("onClear", onClear);
                if (res) {
                    onCancel()
                }
                // onClear()
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch]
    );

    function onView(data) {
        setState({ data, type: 'view', page: 'edit' })
    }
    function onCreate(data) {
        setState({ type: 'edit', page: 'edit' })
    }
    function onEdit(data) {
        setState({ data, type: 'edit', page: 'edit' })
    }
    function onDelete(data) {

    }

    function onClear() {

    }
    async function onCancel() {
        await getProductList({
            ...pagination,
            page: 0
        })
        setState({ page: 'table' })

    }


    const onSubmit = useCallback(
        async (values) => {
            let feeTypeList = values.feeTypeList;


            const modifiedValues = {
                ...values,
                whiteList: values.whiteList ? 'Y' : 'N',
                activeStatus: values.activeStatus ? 'Y' : 'N',
                activeDate: values.activeDate ? values?.activeDate?.format("YYYY-MM-DD") : null,
                expireDate: values.expireDate ? values?.expireDate?.format("YYYY-MM-DD") : null,
                requestId: generateRandomString(),
                companyId: currentCompany,
                // feeTypeList: values.feeTypeList
            };
            delete modifiedValues.feeTypeList

            feeTypeList?.forEach?.((o, index) => {
                modifiedValues[`feeTypeList[${index}].feeType`] = o.feeType
                modifiedValues[`feeTypeList[${index}].feeUnit`] = o.feeUnit
                modifiedValues[`feeTypeList[${index}].feeAmount`] = o.feeAmount
            })

            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    i18n.language === "en"
                        ? "Are you sure confirm to edit company profile ?"
                        : "คุณยืนยันการแก้ไขข้อมูลบริษัทใช่หรือไม่ ?"
                ),
                onOk() {
                    updateProductManagement(modifiedValues);
                },
                okText: t("common.confirm"),
                cancelText: t("common.cancel"),
            });
        },
        [currentCompany, updateProductManagement]
    );

    const productTypeOption = [
        {
            label: 'Payday',
            value: 'payday'
        },
        {
            label: 'Installment Loan',
            value: 'installmentLoan'
        }
    ]
    const columns = [
        {
            title: <div className="text-table">{t("product.product_code")}</div>,
            dataIndex: "productCode",
            key: "productCode",
            align: "center",
            // render: (_, record, idx) => {
            //     console.log("idx ", idx, pagination);
            //     return ((pagination.page) * pagination.size) + (idx + 1);
            // },
        },
        {
            title: <div className="text-table">{t("product.product_name")}</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (_, record, idx) => {
                return <Flex style={{ textAlign: "left" }}>{_}</Flex>
            },
        },
        {
            title: <div className="text-table">{t("product.product_type")}</div>,
            dataIndex: 'productType',
            key: 'productType',
            // sorter: true,
            align: "center",
            render: (_, record, idx) => {
                return <Flex align="left">{productTypeOption.find(o => o.value == _)?.label}</Flex>
            },
        },
        {
            title: <div className="text-table">{t("product.minimum_credit")}</div>,
            dataIndex: 'minCredit',
            key: 'minCredit',
            align: "left",
            // sorter: true,
            render: (_, record) => {
                return (
                    get2DecimalPointsWithCommas(_)
                )
            }
        },
        {
            title: <div className="text-table">{t("product.maximum_credit")}</div>,
            dataIndex: 'maxCredit',
            key: 'maxCredit',
            align: "left",
            // sorter: true,
            render: (_, record) => {
                return (
                    get2DecimalPointsWithCommas(_)
                )
            }
        },
        {
            title: <div className="text-table">{t("product.interest_year")}</div>,
            dataIndex: 'interestRate',
            key: 'interestRate',
            align: "center",
            render: (_, record) => {
                return (
                    (get2DecimalPointsWithCommas(_) + " %")
                )
            }
        },
        {
            title: <div className="text-table">{t("product.fee")}</div>,
            dataIndex: 'feeTypeList',
            key: 'feeTypeList',
            align: "center",
            // sorter: true,
            render: (_, record) => {
                // feeTypeOption

                return (
                    <Flex vertical>
                        {_?.map?.(o => {
                            let model = feeTypeOption.find(id => id.value == o.feeType)
                            let unit = o.feeUnit == 'BATH' ? 'บาท' : '%'
                            return <span>{model.label} {get2DecimalPointsWithCommas(o.feeAmount)} {unit}</span>

                        })}
                    </Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t("product.start_date")}</div>,
            dataIndex: 'activeDate',
            key: 'activeDate',
            align: "center",
            render: (_, record) => {
                return (
                    _ && dayjs(_)?.format?.('DD/MM/YYYY')
                )
            }
        },
        {
            title: <div className="text-table">{t("product.end_date")}</div>,
            dataIndex: 'expireDate',
            key: 'expireDate',
            align: "center",
            render: (_, record) => {
                return (
                    _ && dayjs(_)?.format?.('DD/MM/YYYY')
                )
            }
        },
        {
            title: <div className="text-table">{t("product.status")}</div>,
            dataIndex: 'activeStatus',
            key: 'activeStatus',
            align: "center",
            render: (_, record) => {
                console.log("____", _, record);

                return _ == 'Y' ? t("product.active") : t("product.inactive")
            }
        },
        {
            title: "",
            key: "action",
            width: '80px',
            fixed: "right",
            align: "center",
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: () => onView(record),
                                    label: `${t("action.view")}`,
                                    icon: (
                                        <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                                {
                                    key: "2",
                                    onClick: () => onEdit(record),
                                    label: `${t("action.edit")}`,
                                    icon: (
                                        <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                                {
                                    key: "3",
                                    // onClick: () => onDelete(record?.employeeId), ของเดิม comment ไว้
                                    label: `${t("action.delete")}`,
                                    icon: (
                                        <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        },
    ];

    const getProductList = useCallback(async (page) => {
        try {
            dispatch(setIsLoading(true));
            const response = await services.getProductList({
                ...page
            });
            dispatch(setProductList(response.data?.page?.content || []));
            setPagination({
                ...pagination,
                page: response.data?.page.number,
                current: response.data?.page.number + 1,
                total: response.data?.page?.totalElements,
            });
            dispatch(setIsLoading(false));
        } catch (error) {
            Alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [pagination, currentCompany]);



    useEffect(() => {
        // console.log("currentCompany", currentCompany);

        getProductList({
            ...pagination,
            page: 0
        })
    }, [])
    useEffect(() => {
        // console.log("currentCompany", currentCompany);

        getProductList({
            ...pagination,
            page: 0
        })
    }, [currentCompany])

    function firstRow() {
        return (
            <>
                <Row justify="space-between" align={"middle"}>
                    {/* <Input value={pagination.filter} onChange={(e) => {
                        setPagination({ ...pagination, filter: e.target.value })
                    }} onPressEnter={() => {
                        getProductList(pagination, productCode)
                    }} allowClear placeholder="search" style={{ width: "15%", borderRadius: "24px", height: "100%" }}
                        prefix={<SearchOutlined />} /> */}
                    <Space size={7}>

                        {/* <Button
                            size="large"
                            style={{
                                border: "none", boxShadow: "none", color: "#BFBFBF",
                                padding: 0,
                                width: "19px",
                                height: "40px",
                            }}
                            onClick={() => { setAmountVisible(!amountVisible) }}
                            icon={amountVisible ? <EyeInvisibleOutlined /> : <EyeTwoTone />} /> */}
                        {/* <Select value={productCode} onChange={(e) => { setProductCode(e) }} style={{ width: "7vw" }} options={[{ label: "ทั้งหมด", value: null }, { label: "ป๋า Advance", value: "PA0001" }, { label: "฿Cash", value: "BE0001" }]} className={styles.roundSelect} place
                            holder={t('whiteList..words')} /> */}
                        {/* <Button onClick={() => {
                            services.exportExcelWhitelist().then(res => {
                                console.log("res", res);
                                const url = window.URL.createObjectURL(res.data);
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', "import-whitelist-template.xlsx");
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                            })
                        }} style={{ borderRadius: "24px", backgroundColor: "#5FC0EE", color: "white", border: "none", }}>{t('whiteList..download')}</Button> */}
                        {/* <Button onClick={() => {
                            setOpenModal(true)
                        }} style={{ borderRadius: "24px", backgroundColor: "#30BB80", color: "white", border: "none", }}>{t('whiteList..upload')}</Button> */}
                    </Space>
                </Row></>
        );
    }

    function table() {
        return (
            <TableAntd loading={isLoading} className={styles.customSelect}
                columns={columns}
                dataSource={dataSource}
                style={{ marginTop: "4vh" }}
                onChange={(pagination, filter, sorter) => {
                    console.log("pagination", pagination, sorter);
                    const modifiedSorter = Array.isArray(sorter)
                        ? [...sorter]
                        : [sorter];
                    console.log("modifiedSorter", modifiedSorter);

                    getProductList({
                        filter: pagination?.filter,
                        page: pagination?.current - 1,
                        size: pagination?.pageSize,
                        pageSize: pagination?.pageSize,
                        sortBy: modifiedSorter
                            .filter((s) => s.order !== undefined)
                            .map((s) => ({
                                direction: s.order === "descend" ? "desc" : "asc",
                                property: s.field,
                            })),
                    }, productCode)
                    setPagination({
                        filter: pagination?.filter,
                        page: pagination?.current - 1,
                        size: pagination?.pageSize,
                        pageSize: pagination?.pageSize,
                        sortBy: modifiedSorter
                            .filter((s) => s.order !== undefined)
                            .map((s) => ({
                                direction: s.order === "descend" ? "desc" : "asc",
                                property: s.field,
                            })),
                    })
                }}
                pagination={{
                    ...pagination,
                    showTotal: (total, range) =>
                        t("paginate.description")
                            .replace("{min}", range[0])
                            .replace("{max}", range[1])
                            .replace("{total}", total),
                }}
            />
        )
    }

    const EditPage = useCallback(
        (state) => {

            return <ProductManagementEdit state={{ ...state }} onSubmit={onSubmit} onCancel={onCancel} />
        },
        [onSubmit, onCancel],
    )
    const getPage = useCallback(
        () => {
            if (state.page == 'table') {
                return <>
                    {firstRow()}
                    {table()}
                </>
            } else if (state.page == 'edit') {
                return <EditPage state={state} />
            }
        },
        [state, isLoading, dataSource],
    )

    // firstRow = () => { },
    // table = () => { },
    // EditPage = () => { },


    return {
        firstRow,
        table,
        EditPage,
        onSubmit,
        getPage,
        onCreate,
        state
    };
}

export default useProductManagement;
